export * from './inagentForm.component';
export * from './inagentInfoList.component';
export * from './inagentList.component';

